
import './ShiftWarningModal.css';

const ShiftWarningModal = ({ show, onClose, onAction, timeRemaining }) => {
    if (!show) return null;

    // Determine alert type based on time remaining
    const isCritical = timeRemaining <= 5;

    return (
        <div className="modal-overlay">
            <div className={`modal warning-modal ${isCritical ? 'critical' : ''}`}>
                <div className="modal-header">
                    <h3>
                        <span className="alert-icon" aria-hidden="true">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                        </span>
                        Shift ending soon
                    </h3>
                </div>

                <div className="modal-body" role="alert">
                    <h4>
                        Your shift ends in <span className="highlight">{timeRemaining} minutes</span>.
                    </h4>

                    <p className="text-muted">
                        Finish your current entry and prepare for handover.
                        {isCritical && <strong> Don't start any new large batches.</strong>}
                    </p>
                </div>

                <div className="modal-actions">
                    <button
                        className="btn btn-secondary"
                        onClick={onClose}
                    >
                        Dismiss
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() => onAction('end')}
                    >
                        End shift now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ShiftWarningModal;
